import React, {useState} from 'react';


const TkgTabs = (props) => {

    // Using states to change classes on the tabs
    const [active1, setActive1] = useState('service-button-active');  
    const [active2, setActive2] = useState(''); 

    // Calling this function on click of the different tabs.
    const setTab = (tab) => {
      if (tab === 2) {
        props.setTkgTab(2);
        setActive2('service-button-active');

        setActive1('');
      }  else {
        props.setTkgTab(1);
        setActive1('service-button-active');

        setActive2('');
      }
    }
    return ( <>
        <div className="container-fluid service-selector">
          <div className="container service-buttons">
            <div onClick={() => {setTab(1)}} className={`service-button ${active1}`} type="button" data-toggle="collapse" data-target="#collapseKlasseb" aria-expanded="false" aria-controls="collapseKlasseb">
            <i className="fas fa-chalkboard-teacher service-icon"></i> Dagene <br />
            </div>
            <div onClick={() => {setTab(2)}} className={`service-button ${active2}`} type="button" data-toggle="collapse" data-target="#collapseKlassebe" aria-expanded="false" aria-controls="collapseKlassebe">
            <i className="fas fa-car service-icon"></i> Påmelding
            </div>
          </div>
        </div>
         
        </>
    )
}

export default TkgTabs
